<template>
  <div v-cloak id="customer_list" class="right_col" role="main">
    <el-row :gutter="20">
      <el-col :span="24">
        <h3>乘客會員資料</h3>
        <hr />
      </el-col>
    </el-row>
    <el-row :gutter="8">
      <el-col :span="4">
        <el-input v-model="kw" placeholder="商家名稱/電話/會員名稱"></el-input>
      </el-col>
      <el-button-group>
        <el-button
          type="primary"
          @click="onSearch"
          icon="el-icon-search"
          :loading="isSearchBtnLoading"
        >
          搜尋
        </el-button>
        <el-button type="success" @click="onAddMember" icon="el-icon-plus">
          新增會員
        </el-button>
        <el-button
          type="warning"
          @click="dialogVisible = true"
          icon="el-icon-edit"
        >
          修改上車備註
        </el-button>
      </el-button-group>
    </el-row>

    <div class="row">
      <div class="x_content move_down">
        <el-select
          v-model="paging.npp"
          @change="onNpp"
          style="max-width: 10rem"
        >
          <el-option v-for="npp in [10, 25, 50, 100]" :value="npp" :key="npp">
            {{ npp }}
          </el-option>
        </el-select>
        <div class="table-responsive">
          <table
            v-loading="isTableLoading"
            class="table table-striped jambo_table bulk_action"
          >
            <thead>
              <tr class="headings fontSize16">
                <th class="column-title">會員名稱</th>
                <th class="column-title">商家名稱</th>
                <th class="column-title">性別</th>
                <th class="column-title">聯絡電話(最新一筆)</th>
                <th class="column-title">來電電話</th>
                <th class="column-title">紀錄</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(customer, idx) in customerList">
                <tr class="pointer fontSize16" :key="idx">
                  <td>{{ customer.name }}</td>
                  <td>{{ customer.storeName }}</td>
                  <td>{{ customer.gender ? '男' : '女' }}</td>
                  <td>{{ customer.contactPhone }}</td>
                  <td>{{ customer.phone }}</td>
                  <td>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="setCustomerInfo(customer)"
                    >
                      檢視
                    </el-button>
                    <el-button
                      type="default"
                      size="mini"
                      @click="recordPage(customer.id, '乘客資料')"
                    >
                      活動紀錄
                    </el-button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--頁籤-->
        <el-row type="flex" justify="center">
          <el-col>
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="onPageChange"
              :current-page="paging.currentPage"
              :page-count="paging.totalPages"
            />
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      :title="'上車備註修改'"
      :visible.sync="dialogVisible"
      :lock-scroll="false"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-input v-model="input_note" placeholder="上車備註"></el-input>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="addNewNote">新增</el-button>
        </el-col>
      </el-row>
      <table v-loading="isFetchNote" class="note-tab disable-select">
        <thead>
          <tr>
            <td>上車備註</td>
            <td>動作</td>
          </tr>
        </thead>
        <tbody
          is="draggable"
          v-model="notes"
          element="tbody"
          :force-fallback="true"
          :scroll-sensitivity="200"
          ghost-class="ghost"
        >
          <tr v-for="(item, idx) in notes" :key="item.id">
            <td>
              <el-input v-model="notes[idx].note" />
            </td>
            <td>
              <el-button size="mini" @click="onEdit(item)">更新</el-button>
              <el-button size="mini" type="danger" @click="onDelete(item)">
                刪除
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="isSortBtnLoading"
          type="success"
          @click="updateNotePosition"
        >
          更新排序
        </el-button>
        <el-button type="default" @click="dialogVisible = false">
          關閉
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cookies } from '@/utils/cookies'
import { reqCustomerList } from '@/api/customerInfo'
import { mapGetters } from 'vuex'
import { Notification } from 'element-ui'
import draggable from 'vuedraggable'
import 'vue-loading-overlay/dist/vue-loading.css'
import CustomerInfo from './CustomerInfo.vue'
import NoteAPI from '@/assets/js/libs/FirebaseAPI/Note'

export default {
  components: {
    CustomerInfo,
    draggable,
  },
  name: 'CustomerList',
  data() {
    return {
      // customer list
      kw: '',
      customerList: [],
      isTableLoading: false,
      isSearchBtnLoading: false,
      paging: {
        currentPage: 1,
        npp: 10,
        totalPages: 1,
        totalEntries: null,
      },
      // note
      dialogVisible: false,
      input_note: '',
      notes: [],
      oldNotes: [],
      isSortBtnLoading: false,
      isFetchNote: false,
      //filter_list_by_search: [],
      //list: [],
      //fullPage: false,
      //sortBy: 'call_number',
      //orderBy: true,
    }
  },
  methods: {
    async fetchList(page = null) {
      try {
        if (page) {
          this.isTableLoading = true
          this.paging.currentPage = page
        } else {
          this.isSearchBtnLoading = true
          this.isTableLoading = true
        }
        const { result } = await reqCustomerList({
          npp: this.paging.npp,
          page: this.paging.currentPage,
          kw: this.kw,
        })
        this.customerList = result.customerArray
        this.paging.totalPages = result.paging.totalPages
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: '搜尋乘客會員資料失敗，請稍後再試',
        })
      } finally {
        this.isSearchBtnLoading = false
        this.isTableLoading = false
      }
    },
    onSearch() {
      this.fetchList(1)
    },
    onPageChange(page) {
      this.paging.currentPage = page
      this.fetchList()
    },
    onNpp() {
      this.fetchList(1)
    },
    onAddMember() {
      this.$router.push({ path: '/serviceMain/customerInfo' })
    },
    addNewNote() {
      const code = cookies.get('GladTeamCode')
      const customer = this.getCustomer()
      NoteAPI.post('/', {
        customer_id: customer.customer_id,
        service_name: customer.service_name,
        note_name: this.input_note,
        code: parseInt(code),
      })
        .then((res) => {
          // console.log(res)
          if (res.success) {
            this.$msg('更新成功')
            this.input_note = ''
            this.getNote()
          } else {
            this.$msg('更新失敗:' + res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCustomer() {
      const serviceName = cookies.get('GladName')
      const manager = this.managerList.find(
        (manager) => manager.managerName === serviceName,
      )
      if (manager) {
        return { customer_id: manager.id, service_name: serviceName }
      } else {
        throw new Error('manager is not found')
      }
    },
    onDelete(row) {
      const customer = this.getCustomer()
      NoteAPI.delete('/seal?id=' + row.id, {
        data: {
          customer_id: customer.customer_id,
          service_name: customer.service_name,
        },
      })
        .then((res) => {
          console.log(res)
          if (res.success) {
            this.$msg('更新成功')
            this.getNote()
          } else {
            this.$msg('更新失敗:' + res.message)
          }
        })
        .catch((e) => {
          console.error(e)
        })
    },
    onEdit(row) {
      const customer = this.getCustomer()
      NoteAPI.put('/update?id=' + row.id, {
        customer_id: customer.customer_id,
        service_name: customer.service_name,
        note_name: row.note,
        position: row.position,
      })
        .then((res) => {
          console.log(res)
          if (res.success) {
            this.$msg('更新成功')
          } else {
            this.$msg('更新失敗:' + res.message)
          }
        })
        .catch((e) => {
          console.error(e)
        })
    },
    //filterListByKwAndNpp() {
    //  this.filter_list_by_search = this.list.filter((driver) => {
    //    let haskey = false
    //    for (var key in driver) {
    //      if (key == 'id') continue
    //      driver[key].toString()
    //      if (driver[key].toString().includes(this.kw)) {
    //        haskey = true
    //      }
    //    }
    //    return haskey
    //  })
    //  this.filter_list_by_search = this.filter_list_by_search.sort(this.sort)
    //
    //  this.filter_list = this.filter_list_by_search.filter((_, index) => {
    //    return (
    //      index >= this.npp * (this.page - 1) && index < this.npp * this.page
    //    )
    //  })
    //},
    //sort(a, b) {
    //  if (this.orderBy) return a[this.sortBy] - b[this.sortBy]
    //  else return b[this.sortBy] - a[this.sortBy]
    //},
    //onDetailBtnClick(id) {
    //  cookies.set('driver', id)
    //  location.href = 'driver_edit.html'
    //},
    setCustomerInfo(customer) {
      const routeData = this.$router.resolve({
        name: 'CustomerInfo',
        query: { id: customer.id },
      })
      window.open(routeData.href, '_blank')
    },
    recordPage(id, type) {
      const routeData = this.$router.resolve({
        name: 'activityRecord',
        query: { id: id, type: type },
      })
      window.open(routeData.href, '_blank')
    },
    getNote() {
      this.isFetchNote = true
      NoteAPI.get(`?code=${cookies.get('GladTeamCode')}`)
        .then((res) => {
          this.notes = res.result
          this.oldNotes = res.result
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => (this.isFetchNote = false))
    },
    updateNotePosition() {
      this.isSortBtnLoading = true
      // console.log(this.notes)
      // console.log(this.oldNotes)
      const updateNotes = []
      for (let i = 0; i < this.notes.length; i++) {
        const newNote = this.notes[i]
        const oldNote = this.oldNotes[i]
        if (
          newNote.id !== oldNote.id ||
          newNote.position !== oldNote.position
        ) {
          newNote.position = i + 1
          updateNotes.push(newNote)
        }
      }
      // console.log(updateNotes)
      const customer = this.getCustomer()
      const promises = updateNotes.map(({ id, note, position }) => {
        return NoteAPI.put('/update?id=' + id, {
          customer_id: customer.customer_id,
          service_name: customer.service_name,
          note_name: note,
          position: position,
        })
      })
      Promise.all(promises)
        .then(() => {
          this.getNote()
          Notification({
            type: 'success',
            message: '更新排序成功',
          })
        })
        .catch((e) => {
          console.error(e)
          Notification({
            type: 'error',
            message: '更新排序失敗',
          })
        })
        .finally(() => (this.isSortBtnLoading = false))
    },
  },
  computed: {
    ...mapGetters({
      managerList: 'managerStore/getManagerList',
    }),
  },
  mounted() {
    this.getNote()
  },
}
</script>

<style scoped>
h4 {
  min-width: 140px;
}

input.inputstyle {
  min-width: 240px;
}

.customer-form {
  border: 2px gray solid;
  padding: 20px;
}

.note-tab {
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
  margin: 1rem auto;
}

.note-tab > tbody {
  height: 200px;
  overflow-y: scroll;
}

.note-tab tr,
.note-tab td {
  border: 1px solid black;
}

.note-tab tr:hover {
  cursor: grab;
}

.note-tab tr:active {
  cursor: grabbing;
}

.note-tab td {
  padding: 1rem;
}

.disable-select {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/CustomerList.vue